import { render } from "./PageHeaderMultimediaHeaderTwoCols.vue?vue&type=template&id=355d72f7"
import script from "./PageHeaderMultimediaHeaderTwoCols.vue?vue&type=script&lang=js"
export * from "./PageHeaderMultimediaHeaderTwoCols.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__